<template><svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 608.95 659.96" style="enable-background:new 0 0 608.95 659.96;" xml:space="preserve">
<g>
	<g>
		<path class="st0" d="M304.47,659.96c-30.74,0-61.49-13.9-109.65-41.71l-85.17-49.18C13.32,513.46,0,490.39,0,379.15v-98.35
			C0,169.58,13.32,146.5,109.65,90.89l85.17-49.17c96.33-55.62,122.97-55.62,219.3,0l85.17,49.17
			c96.33,55.61,109.65,78.69,109.65,189.92v98.35c0,111.23-13.32,134.3-109.65,189.92l-85.17,49.17
			C365.96,646.06,335.22,659.96,304.47,659.96z M304.47,31.07c-24.7,0-51.08,12.63-94.15,37.49l-85.17,49.17
			c-43.07,24.87-67.2,41.4-79.54,62.79C33.26,201.91,31,231.07,31,280.81v98.35c0,49.73,2.26,78.9,14.61,100.28
			s36.48,37.92,79.54,62.79l85.17,49.17c43.07,24.87,69.46,37.49,94.15,37.49s51.08-12.62,94.15-37.49l85.17-49.17
			c43.07-24.87,67.2-41.4,79.54-62.79s14.61-50.55,14.61-100.28v-98.35c0-49.73-2.26-78.9-14.61-100.28
			c-12.35-21.39-36.47-37.92-79.54-62.79l-85.17-49.17C355.55,43.69,329.17,31.07,304.47,31.07z"/>
	</g>
	<g>
		<g>
			<path class="st0" d="M501.63,484.06H107.31c-9.83,0-17.82-8-17.82-17.82V193.72c0-9.83,8-17.82,17.82-17.82h394.32
				c9.83,0,17.82,8,17.82,17.82v272.52C519.46,476.07,511.46,484.06,501.63,484.06z M120.49,453.06h367.97V206.9H120.49V453.06z"/>
		</g>
		<g>
			<g>
				<path class="st0" d="M460.73,419.34H148.21c-8.56,0-15.5-6.94-15.5-15.5s6.94-15.5,15.5-15.5h312.52c8.56,0,15.5,6.94,15.5,15.5
					S469.29,419.34,460.73,419.34z"/>
			</g>
			<g>
				<path class="st0" d="M206.78,305.35l-26.18,43.78c-2.1,4.11-4.63,7.23-7.58,9.36c-2.95,2.14-4.83,3.2-9.61,3.2
					c-5.05,0-8.17-1.27-11.35-3.82c-3.18-2.55-4.77-5.74-4.77-9.57v-94.22c0-3.83,1.59-7.04,4.77-9.61
					c3.18-2.57,6.3-3.86,11.35-3.86c5.05,0,7.19,1.29,10.4,3.86c3.21,2.57,4.82,5.78,4.82,9.61v42.88h1.97l26.18-43.7
					c2.1-4.16,4.61-7.31,7.53-9.45c2.92-2.14,4.77-3.2,9.56-3.2c5.05,0,8.17,1.29,11.35,3.86c3.18,2.57,4.77,5.78,4.77,9.61v94.22
					c0,3.83-1.59,7.02-4.77,9.57c-3.18,2.55-6.3,3.82-11.35,3.82s-7.17-1.27-10.35-3.82c-3.18-2.55-4.77-5.74-4.77-9.57v-42.96
					H206.78z"/>
				<path class="st0" d="M350.83,348.31c0,3.83-1.59,7.02-4.77,9.57c-3.18,2.55-6.3,3.82-11.35,3.82c-5.05,0-7.17-1.27-10.35-3.82
					c-3.18-2.55-4.77-5.74-4.77-9.57v-32.86h-28.15v32.86c0,3.83-1.61,7.02-4.82,9.57c-3.22,2.55-5.35,3.82-10.4,3.82
					s-8.17-1.27-11.35-3.82c-3.18-2.55-4.77-5.74-4.77-9.57v-94.22c0-3.83,1.59-7.04,4.77-9.61c3.18-2.57,6.3-3.86,11.35-3.86
					s7.19,1.29,10.4,3.86c3.21,2.57,4.82,5.78,4.82,9.61v34.5h28.15v-34.5c0-3.83,1.59-7.04,4.77-9.61
					c3.18-2.57,5.3-3.86,10.35-3.86c5.05,0,8.17,1.29,11.35,3.86c3.18,2.57,4.77,5.78,4.77,9.61V348.31z"/>
				<path class="st0" d="M461.66,348.31c0,3.83-1.59,7.02-4.77,9.57c-3.18,2.55-6.3,3.82-11.35,3.82c-5.05,0-7.17-1.27-10.35-3.82
					c-3.18-2.55-4.77-5.74-4.77-9.57v-32.86h-28.15v32.86c0,3.83-1.61,7.02-4.82,9.57c-3.22,2.55-5.35,3.82-10.4,3.82
					s-8.17-1.27-11.35-3.82c-3.18-2.55-4.77-5.74-4.77-9.57v-94.22c0-3.83,1.59-7.04,4.77-9.61c3.18-2.57,6.3-3.86,11.35-3.86
					s7.19,1.29,10.4,3.86c3.21,2.57,4.82,5.78,4.82,9.61v34.5h28.15v-34.5c0-3.83,1.59-7.04,4.77-9.61
					c3.18-2.57,5.3-3.86,10.35-3.86c5.05,0,8.17,1.29,11.35,3.86c3.18,2.57,4.77,5.78,4.77,9.61V348.31z"/>
			</g>
		</g>
	</g>
</g>
</svg>
</template>